import type * as Blockly from 'blockly/core';
import { expr, registerSetupCode, resolveDigitalPin } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export const temperatureGlobalCodes = new Map<string, string>();
export const temperatureHelperCode = `float _sbeGetTemperature(DallasTemperature& sensors) {\n  sensors.requestTemperatures();\n  return sensors.getTempCByIndex(0);\n}\n`;

let _used = false;

export function temperatureUsed(): boolean {
    return _used;
}

export function resetTemperature(): void {
    _used = false;
    temperatureGlobalCodes.clear();
}

export function register(gen: any): void {
    gen.forBlock['temperature'] = function (block: Blockly.Block): [string, number] {
        const pin = resolveDigitalPin(block);
        const varName = `_tempSensors_${pin}`;
        const wireVarName = `_tempWire_${pin}`;

        temperatureGlobalCodes.set(
            pin,
            `OneWire ${wireVarName}(${pin});\nDallasTemperature ${varName}(&${wireVarName});\n`,
        );
        registerSetupCode(pin, `  ${varName}.begin();\n  ${varName}.setResolution(SENSOR_BIT);\n`);

        _used = true;
        return expr(`_sbeGetTemperature(${varName})`);
    };
}
